import { useEffect, useRef } from "react";

export function useDebounce<T>(
  value: T,
  onChange: (value: T) => void,
  delay: number
): void {
  const latestOnChange = useRef(onChange);

  // Keep ref up to date with latest onChange callback
  useEffect(() => {
    latestOnChange.current = onChange;
  }, [onChange]);

  // Debounce the value changes
  useEffect(() => {
    const handler = setTimeout(() => {
      latestOnChange.current(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);
}
